"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = (0, _makeStyles.default)(function (theme) {
  return {
    gallery: {
      "& .mco-gallery-02-swiper-nav__prev": _defineProperty({
        background: "rgba(0, 0, 0, 0.5)",
        borderRadius: 0,
        width: 40,
        "&.swiper-button-disabled": {
          opacity: 0,
          pointerEvents: "none"
        },
        "& svg": _defineProperty({
          width: "8px !important"
        }, theme.breakpoints.up("md"), {
          width: "12px !important"
        })
      }, theme.breakpoints.up("md"), {
        width: 56
      }),
      "& .mco-gallery-02-swiper-nav__next": _defineProperty({
        background: "rgba(0, 0, 0, 0.5)",
        borderRadius: 0,
        width: 40,
        "&.swiper-button-disabled": {
          opacity: 0,
          pointerEvents: "none"
        },
        "& svg": _defineProperty({
          width: "8px !important"
        }, theme.breakpoints.up("md"), {
          width: "12px !important"
        })
      }, theme.breakpoints.up("md"), {
        width: 56
      }),
      "& .mco-gallery-02-thumb-swiper": {
        marginTop: theme.spacing(2),
        "&__item": _defineProperty({
          width: "40px !important"
        }, theme.breakpoints.up("md"), {
          width: "56px !important"
        })
      }
    },
    fallbackImage: {
      paddingBottom: "62.71379703534778%",
      position: "relative",
      width: "100%",
      "& .mco-fallback-image": {
        left: 0,
        position: "absolute",
        top: 0
      }
    }
  };
});
var _default = styles;
exports.default = _default;